exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lbl.lbl-required[data-v-96c9ce6a]:after{font-size:14px}.lbl-big-required[data-v-96c9ce6a]:after,.lbl.lbl-required[data-v-96c9ce6a]:after{content:\"*\";color:#d54141;font-family:Open Sans,sans-serif;font-weight:400;padding-left:5px}.lbl-big-required[data-v-96c9ce6a]:after{font-size:18px}.field-validation-error[data-v-96c9ce6a]{color:#d54141;font-family:Open Sans,sans-serif;font-size:13px;font-weight:400;margin-bottom:0}", ""]);

// exports
